<template>
    <div ref="dropdownWrapper"
        :class="['inline-flex items-center space-x-2 bg-white rounded-full py-[3px] pr-0.5 pl-4 shadow-[0px_0px_10px_0px_#00000026] mobile:hidden tablet:flex', globalEntitiesClass]">
        <span class="text-[13px] largeDesktop:text-[14px] font-poppins text-[#333333]">Show entries</span>
        <div class="relative">
            <button
                class="flex items-center justify-between text-[14px] font-poppins font-semibold pl-3 pr-2 py-1.5 w-20 text-white bg-customYellow-100 rounded-full focus:outline-none"
                @click="toggleDropdown">
                {{ selected }}
                <img src="../../assets/images/up-doen-arrow.svg" alt="Up Down Arrow" class="w-5 h-5">
            </button>
            <ul v-if="isOpen" class="absolute z-10 mt-1 w-full bg-white rounded shadow-lg text-gray-700 text-sm p-0">
                <li v-for="option in options" :key="option" @click="select(option)"
                    class="px-4 py-2 hover:bg-indigo-100 cursor-pointer text-center">
                    {{ option }}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        globalEntitiesClass: {
            type: String,
            default: '',
        },
        modelValue: {
            type: Number,
            default: 5,
        },
    },
    data() {
        return {
            options: [25, 50, 100],
            isOpen: false,
        };
    },
    computed: {
        selected: {
            get() {
                return this.modelValue;
            },
            set(val) {
                this.$emit('update:modelValue', val);
            },
        },
    },
    mounted() {
            document.addEventListener('click', this.handleClickOutside);
        },
        unmounted() {
            document.removeEventListener('click', this.handleClickOutside);
        },
    methods: {
        toggleDropdown() {
            this.isOpen = !this.isOpen;
        },
        select(value) {
            this.selected = value;
            this.isOpen = false;
            this.$emit('update:entries', value); // emit change if needed
        },
        handleClickOutside(event) {
            if (this.isOpen && !this.$refs.dropdownWrapper.contains(event.target)) {
                this.isOpen = false;
            }
        },
    },
};
</script>
